import {Button, Grid, TableCell, TableRow, Typography} from "@material-ui/core";
import React from "react";
import {useSelectAllRowStyles} from "./SelectAllRowStyles";
import PropTypes from "prop-types";

const SelectAllRow = (props) => {
    const classes = useSelectAllRowStyles();

    return (
        <TableRow className={classes.root}>
            <TableCell colSpan={props.colSpan} align="center">
                <Grid container alignItems="center" justifyContent="center">
                    <Typography variant="body2" className={classes.typography}>
                        Hai selezionato tutte le righe della pagina
                    </Typography>
                    <Button color="primary" onClick={props.handleSelectAllButton}>
                        Seleziona tutte le {props.totalRows} righe nella ricerca
                    </Button>
                </Grid>
            </TableCell>
        </TableRow>
    )
}

SelectAllRow.propTypes = {
    colSpan: PropTypes.number.isRequired,
    totalRows: PropTypes.number.isRequired,
    handleSelectAllButton: PropTypes.func.isRequired
}

export default SelectAllRow
